module.exports = __webpack_public_path__ + "static/media/logo.286d9051.svg";